export default ".tabs{min-height:550px;margin-top:16px !important}.tabs .ant-tabs-tab{padding-left:0 !important}";